<template>
  <div class="mt-2 text-center">
    <div class="flex justify-center items-center gap-1">
      <button
        :disabled="product.mojodi === 0"
        @click="incrementCount"
        class="w-6 h-6 flex items-center justify-center text-xs rounded border"
        :class="
          product.mojodi === 0
            ? 'bg-gray-200 text-gray-400'
            : 'bg-yellow-100 hover:bg-yellow-200 text-yellow-800'
        "
      >
        +
      </button>

      <span class="text-xs cursor-pointer" @click="openModal">
        {{ count }} بسته
      </span>

      <button
        :disabled="product.mojodi === 0"
        @click="decrementCount"
        class="w-6 h-6 flex items-center justify-center text-xs rounded border"
        :class="
          product.mojodi === 0
            ? 'bg-gray-200 text-gray-400'
            : 'bg-yellow-100 hover:bg-yellow-200 text-yellow-800'
        "
      >
        -
      </button>
    </div>

    <input
      type="tel"
      v-model="inputCount.value"
      @focus="openModal"
      :disabled="product.mojodi === 0"
      class="mt-1 w-12 h-6 text-center text-xs rounded border border-gray-300"
      :class="product.mojodi === 0 ? 'bg-gray-100 text-gray-400' : ''"
    />
  </div>

  <transition name="fade">
    <div
      v-if="modalCount"
      class="fixed inset-0 bg-black bg-opacity-30 z-30 flex items-center justify-center"
      @click="closeModal"
    >
      <div
        @click.stop
        class="bg-white w-[90%] max-w-xs rounded-md p-3 shadow-md text-[13px]"
      >
        <h2 class="text-center font-semibold mb-1">تعداد درخواستی</h2>
        <form @submit.prevent="incrementMultiCount">
          <VInput
            type="text"
            placeholder="تعداد"
            class="w-full"
            v-model="inputCount.value"
            :error="inputCount.error"
            @keydown="inputCount.error = ''"
            required
          />
          <span class="text-xs text-red-500 block mt-1" v-if="inputCount.error">
            {{ inputCount.error }}
          </span>
          <button
            type="submit"
            class="mt-2 w-full bg-yellow-100 hover:bg-yellow-200 text-yellow-800 text-sm py-1 rounded"
          >
            ثبت
          </button>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import VInput from "./General/VInput.vue";

export default {
  name: "ProductOrderButtons",
  components: { VInput },
  props: ["product"],
  data() {
    return {
      modalCount: false,
      inputCount: {
        value: "",
        error: "",
      },
    };
  },
  computed: {
    count() {
      return this.$store.getters["cart/productCount"](this.product.kala_Code);
    },
  },
  methods: {
    incrementCount() {
      this.$store.dispatch("cart/addProduct", this.product).catch((err) => {
        this.showError(err);
      });
    },
    incrementMultiCount() {
      const parsedValue = parseInt(this.inputCount.value);
      if (!parsedValue || parsedValue <= 0) {
        this.inputCount.error = "تعداد معتبر وارد کنید";
        return;
      }

      this.modalCount = false;

      this.$store
        .dispatch("cart/addCountProduct", {
          product: this.product,
          count: parsedValue,
        })
        .catch((err) => {
          this.inputCount.value = "";
          this.showError(err);
        });
    },
    decrementCount() {
      this.$store.dispatch("cart/removeProduct", this.product);
    },
    openModal() {
      if (this.product.mojodi !== 0) {
        this.modalCount = true;
      }
    },
    closeModal() {
      this.modalCount = false;
    },
    showError(err) {
      this.$swal({
        icon: "error",
        title: "خطا",
        text: err,
        confirmButtonColor: "#fcd34d",
        confirmButtonText: "باشه",
      });
    },
  },
};
</script>

<style scoped></style>
